module.exports = __webpack_public_path__ + "img/homebannerbg3.69124205.png";